module.exports = __webpack_public_path__ + "img/13.3a87d019.jpg";